export const getMappedskillObject = (state: any, data: any) => {
  //  if (data.status === 1){
  return {
    key: data.sid,
    name: data.skill_name,
    status: data.status
  };
  //  }

};
export const getMappedreporttoObject = (state: any, data: any) => {
  return {
    key: data.UserID,
    name: data?.UserName,
  };
};

export const getMappedreporttoSupObject = (state: any, data: any) => {
  if(data?.roleid == 3){
    return {
      key: data.UserID,
      name: data?.UserName,
    };
  }
};

export const getMappedroutingObject = (state: any, data: any) => {
  return {
    key: data.rid,
    status: data.status,
    name: data.routing_prof_name,
  };
};

export const mapResponseDataToSkillData = (state: any, data: any) => {
  const skillList: any = [];
  for (const datum of data) {
    skillList.push(getMappedskillObject(state, datum));
  }
  state.skillData = skillList;
};

export const mapResponseDataToreportToData = (state: any, data: any) => {
  const reportToList_agent: any = [];
  const reportToList_Sup: any = [];

  for (const datum of data) {
    reportToList_agent.push(getMappedreporttoObject(state, datum));
    reportToList_Sup.push(getMappedreporttoSupObject(state, datum));
  }
  state.userListByrole = reportToList_agent;
  state.userListByrole_sup = reportToList_Sup?.filter((d :any)=> d) ;
};

export const mapResponseDataToroutingProfileData = (state: any, data: any) => {
  const RoutingProfileList: any = [];
  for (const datum of data) {
    RoutingProfileList.push(getMappedroutingObject(state, datum));
  }
  state.routingProfileData = RoutingProfileList;
};
